// global color variables
export const colors = {
  darkgray: "#3A3A3A",
  gray: "#707070",
  alexwhite: "#fff",
  red: "#7C3A2B",
  orange: "#B26C29",
  teal: "#1D5562",
  blue: "#263752",
  lightgreen: "#E7E6D7",
  darkgreen: "#969A8A",
  tan: "#C0B8AD",
  lighttan: "#E0D5BD",
  coral: "#D6AF8F",
}
